import { render, staticRenderFns } from "./AddItemForClients.vue?vue&type=template&id=48023cbe"
import script from "./AddItemForClients.vue?vue&type=script&lang=js"
export * from "./AddItemForClients.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports